const CONVERSION_OVER_TIME = [
  {
    value: 'NONE',
    view: 'None',
  },
  {
    value: 'DAY',
    view: 'Daily',
  },
  {
    value: 'WEEK',
    view: 'Weekly',
  },
  {
    value: 'MONTH',
    view: 'Monthly',
  },
];

export default CONVERSION_OVER_TIME;
